import { render } from "./SpecificProducts.vue?vue&type=template&id=3334f3de&scoped=true"
import script from "./SpecificProducts.vue?vue&type=script&lang=js"
export * from "./SpecificProducts.vue?vue&type=script&lang=js"

import "./SpecificProducts.vue?vue&type=style&index=0&id=3334f3de&scoped=true&lang=css"
import "./SpecificProducts.vue?vue&type=style&index=1&id=3334f3de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3334f3de"]])

export default __exports__